/* ===========================================================
 *  landing-page.js
 *  - Scroll reveal: section inner fade-in on viewport entry
 *  - Paw animation triggers
 * =========================================================== */
(function () {
  "use strict";

  var SCROLL_REVEAL_SELECTOR = [
    ".lp-underfv__inner",
    ".gift_explanation__inner",
    ".lp-brand-intro__head-inner",
    ".lp-brand-intro__visual",
    ".lp-scenes__inner",
    ".lavande_section__inner",
    ".lp-product-set__inner",
    ".po-product-01__inner",
    ".po-product-02__inner",
    ".lp-gift__inner",
    ".lp-wdr-close__body",
    ".lp-wdr-footer__main",
  ].join(",");

  var SCROLL_REVEAL_OPTIONS = {
    threshold: 0.12,
    rootMargin: "0px 0px 8% 0px",
  };

  var PAW_SCROLL_OPTIONS = {
    threshold: 0.05,
    rootMargin: "0px 0px 8% 0px",
  };

  /** セクション中央付近で足跡を発火（ビューポート中央帯との交差） */
  var PAW_CENTER_OPTIONS = {
    threshold: 0,
    rootMargin: "-50% 0px -50% 0px",
  };

  /** セクション単位で足跡を発火する設定（slug → IntersectionObserver options） */
  var PAW_SECTION_TRIGGERS = [
    { slug: "lp-underfv", options: PAW_CENTER_OPTIONS },
    { slug: "lp-scenes", options: { threshold: 0, rootMargin: "0px 0px 8% 0px" } },
    { slug: "po-product-01", options: { threshold: 0, rootMargin: "0px 0px 8% 0px" } },
    { slug: "po-product-02", options: { threshold: 0, rootMargin: "0px 0px 8% 0px" } },
    { slug: "lp-gift", options: { threshold: 0, rootMargin: "0px 0px 8% 0px" } },
  ];

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  function initScrollReveal(reducedMotion) {
    var targets = document.querySelectorAll(SCROLL_REVEAL_SELECTOR);
    if (!targets.length) return;

    Array.prototype.forEach.call(targets, function (el) {
      el.classList.add("lp-scroll-reveal");
    });

    if (reducedMotion) {
      Array.prototype.forEach.call(targets, function (el) {
        el.classList.add("lp-scroll-reveal--inview");
      });
      return;
    }

    if ("IntersectionObserver" in window) {
      var revealObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("lp-scroll-reveal--inview");
            revealObs.unobserve(entry.target);
          }
        });
      }, SCROLL_REVEAL_OPTIONS);

      Array.prototype.forEach.call(targets, function (el) {
        revealObs.observe(el);
      });
    } else {
      Array.prototype.forEach.call(targets, function (el) {
        el.classList.add("lp-scroll-reveal--inview");
      });
    }
  }

  function initPawAnimations(reducedMotion) {
    var groups = document.querySelectorAll(".paw-group");

    if (reducedMotion) {
      Array.prototype.forEach.call(groups, function (g) {
        g.classList.add("is-visible");
      });
      return;
    }

    var fvGroups = document.querySelectorAll(".lp-fv .paw-group");
    Array.prototype.forEach.call(fvGroups, function (g) {
      g.classList.add("is-visible");
    });

    var others = Array.prototype.filter.call(groups, function (g) {
      return (
        !g.closest(".lp-fv") &&
        !g.closest(".lp-underfv") &&
        !g.closest(".lp-scenes") &&
        !g.closest(".po-product-01") &&
        !g.closest(".po-product-02") &&
        !g.closest(".lp-gift")
      );
    });

    if (others.length) {
      if ("IntersectionObserver" in window) {
        var pawObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              pawObs.unobserve(entry.target);
            }
          });
        }, PAW_SCROLL_OPTIONS);

        others.forEach(function (g) {
          pawObs.observe(g);
        });
      } else {
        others.forEach(function (g) {
          g.classList.add("is-visible");
        });
      }
    }

    function revealSectionPaws(target) {
      var pawLayers = target.querySelectorAll(".paw-group");
      Array.prototype.forEach.call(pawLayers, function (g) {
        g.classList.add("is-visible");
      });
    }

    PAW_SECTION_TRIGGERS.forEach(function (cfg) {
      var sec = document.querySelector("." + cfg.slug);
      if (!sec) return;

      if ("IntersectionObserver" in window) {
        var sectionObs = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                revealSectionPaws(entry.target);
                sectionObs.unobserve(entry.target);
              }
            });
          },
          cfg.options
        );
        sectionObs.observe(sec);
      } else {
        revealSectionPaws(sec);
      }
    });
  }

  function init() {
    var reducedMotion = prefersReducedMotion();
    initScrollReveal(reducedMotion);
    initPawAnimations(reducedMotion);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
